<template>
  <section>
    <application-notification
      v-for="notification in notifications"
      :key="notification.uuid"
      :notification="notification"
    />
  </section>
</template>

<script>
import ApplicationNotification from '@/components/notifications/ApplicationNotification'
import { NotificationService } from '@/service/notification/NotificationService'

/**
 * @property {NotificationService} NotificationService
 */
export default {
  name: 'ApplicationNotifications',
  components: {
    ApplicationNotification
  },
  inject: [NotificationService.provider],
  computed: {
    notifications () {
      const lastAlert = this.NotificationService.alerts.slice(-1)
      if (lastAlert) {
        this.$announcer.set(
          `${lastAlert.type}. ${lastAlert.title}: ${lastAlert.message}`
        )
      }
      return this.NotificationService.alerts
    }
  }
}
</script>
